import Vue from 'vue';
import * as Vuex from 'vuex';
import { getStoreAccessors } from 'vuex-typescript';
import { State } from './state';

Vue.use(Vuex);

type Context = Vuex.ActionContext < State, State > ;

const state: State = {

    loaderActive: false,
    pricesLoader: false,

    auth: {
        isLoggedIn: false,
        isCheckingSession: true,
        verificationInProgress: false,
        user: undefined,
    },

    socket: {
        isConnected: false,
        message: '',
        reconnectError: false,
        prices: '',
    },
    liveStreamId: '',
    liveStreamUrl: '',
    currentShownLot: 0,
    activeLot: 0,
    lots: [],

};

const getters = {
    getLoaderState(state: State) {
        return state.loaderActive;
    },
    getLoggedInState(state: State) {
        return state.auth.isLoggedIn;
    },
    getLoggedInUser(state: State) {
        return state.auth.user;
    },
    getVerificationInProgress(state: State) {
        return state.auth.verificationInProgress;
    },
    getCheckingSession(state: State) {
        return state.auth.isCheckingSession;
    },
    getLiveStreamId(state: State) {
        return state.liveStreamId;
    },
    getLiveStreamUrl(state: State) {
        return state.liveStreamUrl;
    },
};

const mutations = {
    setLoaderVisibility(state: State, loaderState: boolean) {
        state.loaderActive = loaderState;
    },
    setPricesLoaderVisibility(state: State, loaderState: boolean) {
        state.pricesLoader = loaderState;
    },
    setCheckingSession(state: State, checkingState: boolean) {
        state.auth.isCheckingSession = checkingState;
    },
    setVerificationInProgress(state: State, inProgress: boolean) {
        state.auth.verificationInProgress = inProgress;
    },
    setLoggedInState(state: State, loggedInState: boolean) {
        state.auth.isLoggedIn = loggedInState;
    },
    setLoggedInUser(state: State, userData: any) {
        state.auth.user = userData;
    },
    setActiveLot(state: State, lot: number) {
        state.activeLot = lot;
    },
    setLiveStreamId(state: State, streamId: string) {
        state.liveStreamId = streamId;
    },
    setLiveStreamUrl(state: State, streamUrl: string) {
        state.liveStreamUrl = streamUrl;
    }
};

const actions = {
    loginUser(context: Context, loggedInState: boolean) {
        commitLoggedInState(context, loggedInState);
    }
};

export const createStore = () => new Vuex.Store < State >({
    state,
    getters,
    mutations,
    actions,
});

const { read, commit, dispatch } = getStoreAccessors < State, State >('');


/** ********************************************** */
/* GETTERS */
/** ********************************************** */
export const readLoaderVisibility = read(getters.getLoaderState);
export const readLoggedInState = read(getters.getLoggedInState);
export const readLoggedInUser = read(getters.getLoggedInUser);
export const readCheckingSession = read(getters.getCheckingSession);


/** ********************************************** */
/* MUTATIONS */
/** ********************************************** */
export const commitLoaderVisibility = commit(mutations.setLoaderVisibility);
export const commitPricesLoaderVisibility = commit(mutations.setPricesLoaderVisibility);
export const commitCheckingSession = commit(mutations.setCheckingSession);
export const commitVerifcationInProgress = commit(mutations.setVerificationInProgress);
export const commitLoggedInState = commit(mutations.setLoggedInState);
export const commitLoggedInUser = commit(mutations.setLoggedInUser);
export const commitActiveLot = commit(mutations.setActiveLot);
export const commitLiveStreamId = commit(mutations.setLiveStreamId);
export const commitLiveStreamUrl = commit(mutations.setLiveStreamUrl);


/** ********************************************** */
/* ACTIONS */
/** ********************************************** */
export const dispatchLoginUser = dispatch(actions.loginUser);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/store/store.ts